<script setup lang="ts">
import { computed } from 'vue';
import GenericModal from '../modals/GenericModal.vue';

interface Props {
  modelValue: boolean;
  message: string;
  title: string;
  isIos: boolean;
  urlAndroid: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const show = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
function openInBrowser(url: string) {
  window.open(url, '_blank');
}
</script>

<template>
  <GenericModal v-model="show" size="xs" :title="title">
    <div class="w-full">
      <p>{{ message }}</p>
    </div>
    <template v-if="!isIos" #footer>
      <button
        class="bg-backgrounds-darkestgrey hover:bg-backgrounds-darkestgrey/80 focus:ring-backgrounds-darkestgrey flex w-full items-center justify-center rounded-lg px-4 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2"
        @click="openInBrowser(props.urlAndroid)"
      >
        Open in browser
      </button>
    </template>
    <div
      v-if="isIos"
      class="flex flex-col items-center px-4 pb-4 text-center text-white"
    >
      <img
        src="https://storage.googleapis.com/legendaryum-image/help_image"
        alt="How to open in Safari"
        class="rounded-md shadow-md"
      />
      <ol class="max-w-xs list-decimal space-y-1 pl-5 text-left text-sm">
        <li>Tap the three dots at the top right.</li>
        <li>Select “Open in browser.”</li>
      </ol>
    </div>
  </GenericModal>
</template>

<style scoped></style>
